// GeoJSON polygons as rings of [lng, lat]. Points and lines contribute nothing.
function geometryRings(geometry) {
    if (!geometry) return [];
    if (geometry.type === 'Polygon') return geometry.coordinates;
    if (geometry.type === 'MultiPolygon') return geometry.coordinates.flat();
    return [];
}

// Nominatim reverse zoom for a Mapbox place type. 0 means the place has no outline.
const REVERSE_ZOOM = {
    country: 3,
    region: 5,
    district: 8,
    place: 10,
    locality: 12,
    neighborhood: 14,
};

function boundaryZoom(placeType) {
    if (placeType && !REVERSE_ZOOM[placeType]) return 0;
    return REVERSE_ZOOM[placeType] || 10;
}

// Mapbox can tag one place with several types (Budapest is ['region', 'place']); the finest outline is the one picked
function finestPlaceType(types) {
    return (types || []).reduce((best, type) => (boundaryZoom(type) > boundaryZoom(best) ? type : best), types && types[0]) || null;
}

module.exports = { geometryRings, boundaryZoom, finestPlaceType };
